import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons';

library.add(faBars);

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuActive, setMenuActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };

    const closeMenu = () => {
        setMenuActive(false);
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">
                <a href="#home" className="navbar-logo" onClick={closeMenu}>
                    <img src="/UniVerseLogo.png" alt="UniVerse Logo" />
                    <img src="/UniVerseLogo2.png" alt="UniVerse Logo 2" />
                </a>
                <div className={`navbar-links ${menuActive ? 'active' : ''}`}>
                    <a href="#home" className="navbar-link" onClick={closeMenu}>Home</a>
                    <a href="#features" className="navbar-link" onClick={closeMenu}>Features</a>
                    <a href="#testimonials" className="navbar-link" onClick={closeMenu}>Testimonials</a>
                    <a href="#problem" className="navbar-link" onClick={closeMenu}>Problem</a>
                    <a href="#solution" className="navbar-link" onClick={closeMenu}>Solution</a>
                </div>
                <div className="navbar-toggle" onClick={toggleMenu}>
                    <i className="fas fa-bars"></i> {/* Ensure Font Awesome is included */}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;